import { render, staticRenderFns } from "./InFuture.vue?vue&type=template&id=449417ab&scoped=true&lang=pug&"
import script from "./InFuture.vue?vue&type=script&lang=js&"
export * from "./InFuture.vue?vue&type=script&lang=js&"
import style0 from "./InFuture.vue?vue&type=style&index=0&id=449417ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449417ab",
  null
  
)

export default component.exports